import React, { useEffect, useState } from "react";
import { addFile } from "../../services/Storage";

import demo0 from "../../assets/images/demo/1447_b.jpeg";

import OrderConstant from "../../constants/OrderConstant";

import { formatDateDMY, formatDateHM } from "../../utilities/date";
import { toArrayList } from "../../utilities/array";
import { calculateOrder } from "../../utilities/calculate";

import { ReactComponent as SvgCalendar } from "../../assets/images/deal/calendar.svg";
import { ReactComponent as SvgClose } from "../../assets/images/ui/close.svg";
import { ReactComponent as SvgInfo } from "../../assets/images/deal/info.svg";
import { ReactComponent as SvgCube } from "../../assets/images/deal/cube.svg";
import { ReactComponent as SvgPeople } from "../../assets/images/deal/people.svg";

import UiInputText from "../inputs/UiInputText";
import UiModal from "./UiModal";

import "./UiModalDeal.scss";
import UiDropDown from "../inputs/UiDropDown";
import UiTextArea from "../inputs/UiTextArea";
import UiSwitch from "../switch/UiSwitch";
import UiCardAddPhoto from "../cards/UiCardAddPhoto";
import UiTextInputMasked from "../inputs/UiTextInputMasked";
import UiButtonColor from "../button/UiButtonColor";
import UiTableAdaptive from "../table/UiTableAdaptive";

import Env from "../../services/Env";

function UiModalDealAdd(props) {

  const liftTypes = OrderConstant.LIFT_TYPES;

  const [image, setImage] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [load, setLoad] = useState(false);

  const clientsTitles = [
    { sort: false, title: "" },
    { sort: false, title: "" },
    { sort: true, title: "Название" },
    { sort: false, title: "Цена" },
  ];
  const tableListOrders = [
    [
      { button: "delete" },
      { image: demo0 },
      { text: "Название" },
      { text: "5 000 ₽" },
    ],
  ];

  const [order, setOrder] = useState({});

  function uploadList(file) {
    setLoad(true);
    addFile(file, 2).then((res) => {
      console.log(res);
      setLoad(false);
      if (res.success) {
        setImage(res.response);
        setImageUrl(Env.PUBLIC_URL + res.response);
      }
    });
  }

  function init() {
    var DELIVERY_TARIFF = 20,
      MINIMUM_COST = 500,
      myMap = new window.ymaps.Map("map", {
        center: [60.906882, 30.067233],
        zoom: 9,
        controls: [],
      }),
      routePanelControl = new window.ymaps.control.RoutePanel({
        options: {
          showHeader: true,
          title: "Расчёт доставки",
        },
      }),
      zoomControl = new window.ymaps.control.ZoomControl({
        options: {
          size: "small",
          float: "none",
          position: {
            bottom: 145,
            right: 10,
          },
        },
      });
    routePanelControl.routePanel.options.set({
      types: {
        auto: true,
      },
    });
    routePanelControl.routePanel.state.set({
      fromEnabled: false,
      from: order.address_a,
      to: order.address_b,
      type: "auto",
    });
    myMap.controls.add(routePanelControl).add(zoomControl);
    routePanelControl.routePanel.getRouteAsync().then((route) => {
      route.model.setParams(
        {
          results: 1,
        },
        true
      );
      route.model.events.add("requestsuccess", () => {
        var activeRoute = route.getActiveRoute();
        if (activeRoute) {
          var length = route.getActiveRoute().properties.get("distance");
          calculate(Math.round(length.value / 1000));
        }
      });
    });

    function calculate(routeLength) {
      console.log("distance", routeLength);
      updateOrderObj("distance", routeLength);
    }
  }

  useEffect(() => {
    if (window.ymaps) window.ymaps.ready(init);
  }, [order.address_a]);

  useEffect(() => {
    if (props.data) {
      setOrder(props.data)
    }
  }, [props.data])

  /**
   *
   * @param {string} key
   * @param {any} val
   */
  function updateOrderObj(key, val) {
    let _obj = order;
    _obj[key] = val;
    setOrder({ ..._obj });
  }



  return (
    <UiModal name="modal" show={props.modalActive}>
      <div className="modal-deal">
        {props.data ?
          <div className="modal-deal-wrap">
            {/**
           * modal left side - static
           */}
            <div className="modal-deal-about add">
              {/**
             * modal title
             */}
              <div className="modal-deal-about-title">
                <div className="modal-deal-about-title-wrap">
                  <h3>Информация о заказе</h3>
                </div>
              </div>
              {/**
             * modal notifications + msgs
             */}
              <div className="modal-deal-notes">
                <div className="modal-deal-notes-list-wrap">
                  <div className="modal-deal-info">
                    {!props.data.isNew ?
                      <div className="modal-deal-info-form">
                        <UiInputText
                          disabled={true}
                          label="Дата и время"
                          placeholder={`${formatDateDMY(props.data.created_at)}  ${formatDateHM(props.data.created_at)}`}

                        />
                      </div> : null}
                    {!props.data.isNew ?
                      <div className="modal-deal-info-form">
                        <UiInputText
                          disabled={true}
                          label="Номер заказа"
                          placeholder={props.data.id}

                        />
                      </div>
                      : null}
                    {!props.data.isNew ?
                      <div className="modal-deal-info-form">
                        <UiInputText
                          disabled={true}
                          label="Покупатель"
                          placeholder={props.data.name}

                        />
                      </div>
                      : null}
                    <div className="modal-deal-info-form">
                      <UiInputText
                        disabled={!props.data.isNew }
                        label="Телефон покупателя"
                        placeholder={`+${props.data.phone}`}
                        onChange={(val) => updateOrderObj("phone", val)}
                      />
                    </div>
                    {!props.data.isNew ?
                      <div className="modal-deal-info-form">
                        <UiButtonColor
                          color="primary"
                          text="Позвонить"
                          small={true}
                          onClick={() => window.open(`tel:${props.data.phone}`, '_self')}
                        />
                      </div>
                      : null}

                    <div className="added-list">
                      <UiTableAdaptive
                        titleList={clientsTitles}
                        grid={clientsTitles.length}
                        tableList={tableListOrders}
                        search={false}
                      />
                    </div>
                    <UiDropDown
                      label="Выбрать товар"
                      items={[]}
                      onChange={(val) => {

                      }}
                    />
                    <UiButtonColor
                      color="primary"
                      text="Добавить позицию в заказ"
                      small={true}
                      onClick={() => { }}
                    />

                  </div>
                </div>
              </div>
            </div>
            {/**
           * modal right side - tabs
           */}
            <div className="modal-deal-info-wrap">
              {/** close button */}
              <button
                className="modal-deal-info-close"
                onClick={() => props.modalClose()}
              >
                <SvgClose className="modal-deal-info-close-icon" />
              </button>
              <div className="modal-deal-info">
                <h3>Редактировать заказ</h3>

                <div className="modal-deal-info-form">

                  <UiDropDown
                    label="Статус заказа"
                    value={props.data.status}
                    items={toArrayList(OrderConstant.ORDER_TYPES_NAMES)}
                    onChange={(val) => updateOrderObj("status", val)}
                  />

                  <UiInputText
                    label="Сумма заказа"
                    placeholder={props.data.price}
                    onChange={(val) => updateOrderObj("price", val)}
                  />
                  <UiDropDown
                    label="Тип оплаты"
                    value={props.payment_type}
                    items={toArrayList(OrderConstant.ORDER_PAYMENTS_TYPES_NAMES)}
                    onChange={(val) => updateOrderObj("payment_type", val)}
                  />
                  <UiDropDown
                    label="Оплата"
                    value={props.data.is_pay}
                    items={toArrayList(OrderConstant.ORDER_IS_PAY)}
                    onChange={(val) => updateOrderObj("is_pay", val)}
                  />

                  <UiDropDown
                    label="Тип доставки"
                    value={props.moving_types}
                    items={toArrayList(OrderConstant.ORDER_DELIVERY_TYPES_NAMES)}
                    onChange={(val) => updateOrderObj("moving_types", val)}
                  />
                  {props.moving_types == 0 ?
                    <div>
                      <UiInputText
                        label="Дата доставки"
                        placeholder={`${(props.data.date)}`}
                        onChange={(val) => updateOrderObj("date", val)}
                      />
                      <UiInputText
                        label="Время доставки"
                        placeholder={`${(props.data.time)}`}
                        onChange={(val) => updateOrderObj("time", val)}
                      />

                      <UiInputText
                        label="Адрес доставки"
                        placeholder={props.data.address_a}
                        onChange={(val) => updateOrderObj("address_a", val)}
                      />
                    </div> : null}


                  <UiTextArea
                    label="Комментарий"
                    placeholder="Введите комментарий"
                    onChange={(val) => {
                      updateOrderObj("text", val);
                    }}
                  />
                  <UiButtonColor
                    color="primary"
                    text={
                      !props.data.isNew ?
                        "Сохранить" : "Создать"
                    }
                    small={true}
                    onClick={() =>  !props.data.isNew ? props.update(order) :  props.onCreate(order)   }
                  />
                </div>
              </div>
            </div>
          </div> : null}
      </div>
    </UiModal>
  );
}

export default UiModalDealAdd;
